import { Logo } from '@/app/ui/components/logo';
import { useAuth } from '@/app/utils/auth';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';

export const Route = createFileRoute('/(auth)/_layout/activate-account')({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations('pages.activateEmail');
  const { logout } = useAuth();

  return (
    <div className="px-5 -translate-y-5 w-full flex flex-col items-center">
      <Logo className="mb-5 mx-auto" />
      <p className="text-center font-semibold text-lg mb-6">{t('heading', { appName: 'Volve' })}</p>
      <p className="mb-6">{t('headingParagraph')}</p>
      <h2 className="font-semibold mb-2">{t('whyActivationRequired')}</h2>
      <ul className="pb-6 list-disc ml-4">
        <li>{t('toVerifyEmail')}</li>
        <li>{t('toUnlockApp', { appName: 'Volve' })}</li>
      </ul>
      <h2 className="font-semibold mb-2">{t('didntReceiveEmail')}</h2>
      <ul className="pb-6 list-disc ml-4">
        <li>{t('checkSpam')}</li>
        <li>{t('makeSureCorrect')}</li>
      </ul>
      <p>{t('afterActivated')}</p>
      <footer className="pt-6 text-center">
        <span>{t('wantToSignIn')}</span>
        <button
          onClick={logout}
          className="block mt-2 mx-auto text-muted hover:text-foreground underline"
        >
          {t('links.goBackToLogin')}
        </button>
      </footer>
    </div>
  );
}
